<template>
  <div>
    <!-- shopping list details -->
    <v-card class="px-6 mb-4 pt-4" outlined v-if="!shoppingList.Temporary">
      <v-col class="pa-0">
        <h2
          :style="`color: ${$vuetify.theme.themes.light.primary}`"
          class="mb-2"
        >
          {{ $translate('DETAILS') }}
        </h2>
        <p class="mb-1">{{ shoppingListFrequencyText }}</p>
        <p>
          {{ $translate('SHOPPING_LIST_DEADLINE') }}:
          <span class="pl-2">
            {{ formatedDeadline }}
          </span>
        </p>
      </v-col>
    </v-card>

    <!-- pick up / Delivery field cards -->
    <v-card class="px-8 mb-4 py-4" outlined v-if="!shoppingList.Temporary">
      <v-row
        justiy="start"
        v-for="(order, itemIndex) in shoppingList.OrderGroup.Orders"
        :key="itemIndex"
      >
        <!-- Pick up info field-->
        <div v-if="order.OrderType === 'PickUp'">
          <h2
            :style="`color: ${$vuetify.theme.themes.light.primary}`"
            class="mb-2"
          >
            {{ $translate('PICKUP_POINT') }}
          </h2>
          <h4>{{ order.Name }}</h4>
          <v-row class="ma-0">
            <p class="mb-0">{{ order.Street }} {{ order.Nr }}</p>
          </v-row>
          <v-row class="ma-0">
            <p class="mb-0">{{ order.PostalCode }} {{ order.City }}</p>
          </v-row>
        </div>
        <!-- Delivery info field -->
        <div
          v-if="order.OrderType === 'Delivery' || order.OrderType === 'Shiplee'"
        >
          <h2
            :style="`color: ${$vuetify.theme.themes.light.primary}`"
            class="mb-2"
          >
            {{ $translate('DELIVERY_SERVICE') }}
          </h2>
          <p class="mb-1">{{ order.Name }}</p>
          <v-row class="ma-0">
            {{ shoppingList.StartDate }} - {{ shoppingList.StartTime }}
          </v-row>
        </div>
      </v-row>
    </v-card>

    <!-- User details card -->
    <v-card class="px-8 py-4" outlined v-if="!shoppingList.Temporary">
      <v-row justify="start">
        <div>
          <h2
            :style="`color: ${$vuetify.theme.themes.light.primary}`"
            class="mb-2"
          >
            {{ $translate('USER_DETAILS') }}
          </h2>
          <div>{{ shoppingList.Name }}</div>
          <v-row class="ma-0" v-if="shoppingList.Street !== ''">
            {{ shoppingList.Street }} {{ shoppingList.Nr }}
          </v-row>
          <v-row class="ma-0" v-if="shoppingList.PostalCode !== ''">
            {{ shoppingList.PostalCode }} {{ shoppingList.City }}
          </v-row>
          <div
            v-for="(order, indexOrder) in shoppingList.OrderGroup.Orders"
            :key="indexOrder"
          >
            <v-row class="ma-0" justify="start" v-if="order.Note !== ''">
              <h4 class="mr-1">{{ $translate('NOTE') }}:</h4>
              <p class="mb-0">{{ order.Note }}</p>
            </v-row>
          </div>
        </div>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import utility from '@/shared/utility';

export default {
  name: 'ShoppingListDetails',
  props: {
    shoppingList: Object,
  },
  computed: {
    shoppingListFrequencyText() {
      switch (this.shoppingList.Frequency) {
        case 0:
          return this.$translate('ORDER_ONCE');
        case 1:
          return this.$translate('ORDER_EVERY_WEEK');
        case 2:
          return this.$translate('ORDER_EVERY_TWO_WEEKS');
        case 3:
          return this.$translate('ORDER_EVERY_THREE_WEEKS');
        case 4:
          return this.$translate('ORDER_EVERY_FOUR_WEEKS');
        default:
          return '';
      }
    },
    formatedDeadline() {
      return utility.unixTimeToDateTimeString(this.shoppingList.DeadLineUnix);
    },
  },
};
</script>
